import { createGlobalStyle } from 'styled-components'
import type { CLTheme } from 'syf-component-library/defaultTheme'

/*
    createGlobalStyles replaces index.css.
    It's more flexible and consistent with our usage of styled components.
    Learn more about it here: https://www.styled-components.com/docs/api#createglobalstyle
*/

export default createGlobalStyle<CLTheme>`
  body {
    margin: 0;
    height: 100%;
    width: 100%;
    overflow: auto;
    overflow-x: hidden;
  }
  #root {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
      color: ${props => props.body?.background};
      font-family: 'Open Sans';
      overflow: auto;
      min-height: 100vh;
  }
  .margin-top {
    margin-top: 0.75rem;
  }
  .margin-up {
    margin-top: -1.5rem;
  }
  .subtext-up {
    margin-top: 0rem;
    margin-bottom: 1.5rem;
  }
  .react-datepicker__tab-loop {
    margin-right: 0 !important;
  }
  .rectification-checkbox {
    justify-content: center;
    align-self: flex-start;
    margin-bottom: 0;
    margin-top: 1rem;
    margin-right: 1rem;
  }
  .overflow {
    [aria-live='polite'] {
      width: fit-content;
    }
    p {
      white-space: nowrap;
    }
  }
`
